import type { ReactNode } from "react"
import {
  useMemo,
  useState,
} from "react"

import { LocalStorageContext } from "./LocalStorageContext"
import { LocalStorageHandler } from "./LocalStorageHandler"

interface Props {
  children?: ReactNode;
}

export function LocalStorageContextProvider(props: Props) {
  const [
    clearedAt,
    setClearedAt,
  ] = useState<string | undefined>(undefined)

  const value = useMemo(
    () => ({ clearedAt }),
    [clearedAt],
  )

  return (
    <LocalStorageContext.Provider value={value}>
      {props.children}
      <LocalStorageHandler setClearedAt={setClearedAt} />
    </LocalStorageContext.Provider>
  )
}
